import styled from 'styled-components';

const MediaMenuStyled = styled.div(({ theme, style }) => ({
  marginTop: theme.space[2],
  padding: `${theme.space[2]} ${theme.space[3]}`,
  ...style,
}));

export { MediaMenuStyled };
